import React, { useState } from 'react';

// Shared 4-digit PIN entry/setup form for Phil-only pages (Residuals, Hosting).
// The PIN is a screen-privacy gate; Firestore rules are the real boundary.
export default function PinGate({ mode, title, onSubmit, error }) {
  const [pin, setPin] = useState('');
  const [confirm, setConfirm] = useState('');
  const [localError, setLocalError] = useState('');
  const isSetup = mode === 'setup';

  const submit = (e) => {
    e.preventDefault();
    setLocalError('');
    if (!/^\d{4}$/.test(pin)) { setLocalError('PIN must be exactly 4 digits.'); return; }
    if (isSetup && pin !== confirm) { setLocalError('PINs do not match.'); return; }
    onSubmit(pin);
  };

  const pinInput = (value, setValue, placeholder, autoFocus) => (
    <input
      type="password" inputMode="numeric" maxLength={4} autoFocus={autoFocus}
      value={value} placeholder={placeholder}
      onChange={e => setValue(e.target.value.replace(/\D/g, ''))}
      style={{
        fontSize: 28, letterSpacing: 14, textAlign: 'center', width: 180,
        padding: '10px 0 10px 14px', background: 'var(--bg-input)',
        border: '1px solid var(--border)', borderRadius: 10, color: 'var(--text-primary)'
      }}
    />
  );

  return (
    <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 80 }}>
      <form onSubmit={submit} className="card" style={{ width: 340, textAlign: 'center' }}>
        <div style={{ fontSize: 34, marginBottom: 8 }}>🔒</div>
        <div className="card-title" style={{ justifyContent: 'center' }}>
          {isSetup ? 'Create a PIN for this page' : title}
        </div>
        <p style={{ color: 'var(--text-secondary)', fontSize: 13, marginTop: 4 }}>
          {isSetup
            ? 'First visit — choose a 4-digit PIN. You’ll enter it each session to view this page.'
            : 'Enter your 4-digit PIN.'}
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, alignItems: 'center', margin: '14px 0' }}>
          {pinInput(pin, setPin, '••••', true)}
          {isSetup && pinInput(confirm, setConfirm, 'confirm')}
        </div>
        {(localError || error) && (
          <div style={{ color: 'var(--accent-red)', fontSize: 13, marginBottom: 10 }}>{localError || error}</div>
        )}
        <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>
          {isSetup ? 'Set PIN' : 'Unlock'}
        </button>
      </form>
    </div>
  );
}
